export default __webpack_public_path__ + "static/media/@crisalisaquino.f83682d2.jpg";